import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Card, Box, Button, Tabs, Tab, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Accepted from "../../features/classes/Accepted";
import Rejected from "../../features/classes/Rejected";
import Pending from "../../features/classes/Pending";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
} from "../../services/tutor";
import {
  errorToast,
  removeFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../../helpers";
import { useLazyTutorCsvQuery } from "../../services/tutor";
import Loader from "../../helpers/Loader";
import Deleted from "../../features/classes/DeletedTutor";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageClasses = () => {
  const [value, setValue] = useState<number>(0);
  const { state } = useLocation();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (state) {
      setValue(Number(state));
    }
  }, []);

  useEffect(() => {
    removeFromStorage(STORAGE_KEYS.tutorId);
  }, []);
  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Classes</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Pending" {...a11yProps(0)} />
                <Tab label="Approved" {...a11yProps(1)} />
                <Tab label="Rejected" {...a11yProps(2)} />
                <Tab label="Deleted" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Pending />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Accepted />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Rejected />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <Deleted />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageClasses;
